"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(panes) {
    var options = [];
    if (panes) {
        options = panes.map(function (pane) {
            var _a = pane.props, variant = _a.variant, props = __rest(_a, ["variant"]);
            var paneOptions = {};
            if (variant === 'arc') {
                paneOptions = {
                    startAngle: -140,
                    endAngle: 140,
                    background: { shape: 'arc', borderWidth: 0, backgroundColor: '#FFF0' }
                };
            }
            if (variant === 'circle') {
                paneOptions = {
                    startAngle: 0,
                    endAngle: 360,
                    background: { shape: 'arc', borderWidth: 0, backgroundColor: '#FFF0' }
                };
            }
            paneOptions = __assign(__assign({}, paneOptions), props);
            return paneOptions;
        });
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=paneOptions.js.map